import styled from 'styled-components';
import { screenSmMax, cta2FontSize } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';
import {
  AnimationContextType,
  DELAYS,
  fadeInAnimation,
  withAnimationContext,
} from './Animations';

export const Supertext = withAnimationContext(
  styled(Type.p).attrs({
    variant: 'body1',
    weight: Type.book,
  })<{ centered?: boolean; animationContext: AnimationContextType }>`
    ${fadeInAnimation(DELAYS.FIRST)};
    text-align: ${({ centered }) => (centered ? 'center' : 'left')};
    text-transform: uppercase;
    padding-bottom: 0px;

    @media (max-width: ${screenSmMax}) {
      font-size: ${cta2FontSize};
    }
  `,
);
